<template>
  <div class="clear">
    <nav
      class="navbar navbar-inverse navbar-fixed-top"
      class2="navbar-fixed-top"
    >
      <div class="container">
        <div class="navbar-header">
          <a class="navbar-brand" href="/"
            ><img
              v-if="$store.state.webConfig.logo"
              :src="$store.state.webConfig.logo"
          /></a>
          <div class="flexbtn">
            <button
              type="button"
              class="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#navbar"
              aria-expanded="false"
              aria-controls="navbar"
            >
              <span class="sr-only">更多菜单</span>
              <span class="icon-bar top-bar"></span>
              <span class="icon-bar center-bar"></span>
              <span class="icon-bar bottom-bar"></span>
            </button>
          </div>
        </div>
        <div id="navbar" class="collapse  navbar-collapse ">
          <ul class="nav navbar-nav " id="navul">
            <!-- <li :class="{ active: $route.name == 'volunteer' }">
              <div >
                <a class="pa" >我要参与</a>
                <i class="glyphicon glyphicon-plus "></i>
              </div> :class="{ hover: toggle.image }"
            </li> -->
            <li v-for="(val,key) in navData" :key="key" @click="$store.state.webWidth<=765?val.volunteer=!val.volunteer:''"  @mouseover="$store.state.webWidth>765?val.volunteer=true:''" @mouseout="$store.state.webWidth>765?val.volunteer=false:''"> <div v-if="val.show" >
                <a class="pa" v-if="val.link&&val.link.startsWith('http')"  :href="val.link">{{val.name}}</a>
                <a class="pa" v-if="val.link&&!val.link.startsWith('http')"  @click="go(val.link)">{{val.name}}</a>
                <a class="pa" v-if="!val.link" >{{val.name}}</a>
                <i class="glyphicon" v-if="val.sonMenu.length" :class="val.volunteer?'glyphicon-minus':'glyphicon-plus'"></i></div>
                <ul class="son" :class="{'block':val.volunteer}" v-if="val.sonMenu.length" >
                <li v-for="(v,k) in val.sonMenu" :key="k" v>
                <a v-if="v.link&&v.link.startsWith('http')&&v.show"  :href="v.link">{{v.name}}</a>
                <a v-if="v.link&&!v.link.startsWith('http')&&v.show"  @click="go(v.link)">{{v.name}}</a>
                <a v-if="!v.link&&v.show" >{{v.name}}</a>
                  </li>
              </ul>
            </li>

             <!-- <li @click="$store.state.webWidth<=765?toggle.volunteer=!toggle.volunteer:''"  @mouseover="$store.state.webWidth>765?toggle.volunteer=true:''" @mouseout="$store.state.webWidth>765?toggle.volunteer=false:''"> <div >
              <a class="pa">我要参与</a>
               <i class="glyphicon" :class="toggle.volunteer?'glyphicon-minus':'glyphicon-plus'"></i></div>
                <ul class="son" :class="{'block':toggle.volunteer}"  >
                <li><a href="https://www.ximalaya.com/ertong/30520401">听15位名人推荐童书</a></li>
                <li><a href="https://s.weibo.com/weibo?q=%23%E9%98%B3%E5%85%89%E5%85%B3%E7%88%B1%C2%B7i%E8%AF%BB%E8%AE%A1%E5%88%92%23">参与微博讨论</a></li>
                <li><a @click="go({ name: 'volunteer' })">成为志愿者</a></li>
              </ul>
            </li>
            <li
              :class="{ active: $route.name == 'video' }"
              v-if="$store.state.show.video"
            > <div >
              <a class="pa" @click="go('/video/1')"
                >精华视频</a
              ></div>
            </li>
            <li
              :class="{ hover: toggle.image }"
              v-if="$store.state.show.image"
              @click="$store.state.webWidth<=765?toggle.image=!toggle.image:''" 
              @mouseover="$store.state.webWidth>765?toggle.image=true:''"
              @mouseout="$store.state.webWidth>765?toggle.image=false:''"
            > <div >
              <a class="pa" 
                >精彩图集</a
              >
               <i class="glyphicon" :class="toggle.image?'glyphicon-minus':'glyphicon-plus'"></i></div>
                <ul class="son" :class="{'block':toggle.image}"  >
                   <li><a @click="go('/image/1')">精选特辑</a></li>
                <li><a href="https://gallery.vphotos.cn/vphotosgallery/index.html?vphotowechatid=724675495FDBC43DA0C8612CBA217A75">甘肃站直播</a></li>
                <li><a href="https://gallery.vphotos.cn/vphotosgallery/index.html?vphotowechatid=FD1402018DC36538A888AC2D454ADDFD">贵州站直播</a></li>
                <li><a href="https://gallery.vphotos.cn/vphotosgallery/index.html?vphotowechatid=7D2E51B140D3BCEB50D60CFDE13DE5BE">广西站直播</a></li>
                <li><a href="https://gallery.vphotos.cn/vphotosgallery/index.html?vphotowechatid=9FF0260170DE22BDD0981FDDD90587E6">陕西站直播</a></li>
                               
              </ul>
            </li>
            <li
              :class="{ active: $route.name == 'action' }"
              v-if="$store.state.show.news"
            > <div >
              <a class="pa" @click="go('/action/1')"
                >动态资讯</a
              ></div>
            </li>
            <li :class="{ active: $route.name == 'about' }">
               <div ><a class="pa" @click="go({ name: 'about' })">关于</a></div>
            </li> -->
          </ul>
        </div>
        <!--/.nav-collapse -->
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  data() {
    return {
      toggle:{
        volunteer:false,
        image:false
      },
      navData:[]
    }
  },
  mounted() {
    //  $("#navul").find('li').hover(function(e){
    //     $(".son").hide();
    //      $(e.target).find('ul.son').show();
    //   },function(){
    //      $(".son").hide();
    //   })
  },
  created() {
   this.$http.get("/Index/Config/data&key=menu").then(res => {
     res.value.menu.forEach(val=>{
       val.volunteer=false
     })
      this.navData = res.value.menu;
    });
  },
  methods: {
    go($data) {
      this.$router.push($data);
      $("#navbar").collapse("hide");
    }
  }
};
</script>
<style lang="less" scoped>
.glyphicon{
  float: right;
  display: none;
}
.navbar-inverse {
  background-color: #fff !important;
  border-width: 0 !important;
  z-index: 1030;
  height: 100px;

  &.navbar {
    margin-bottom: 0 !important;
  }
  .navbar-collapse {
    border-color: #ccc;
  }
  .navbar-brand {
    padding: 0;
    img {
      height: 100px;
    }
  }

  .margin-bottom {
    margin-bottom: 0 !important;
  }

  .navbar-nav {
    margin: 30px;
    float: right;
    li {
      position: relative;
      ul.son {
        position: absolute;
        list-style-type: none;
        background: #fff;
        // width: 400px;
         padding-top: 40px;
        display: none;
        &.block{
          display: block;
        }
        li {
          line-height: 40px;
          white-space: nowrap;
          padding:5px 25px;
          display: block;
          text-align: left;
          a {
            font-weight: lighter !important;
            text-align: center;
            color: #000000;
            font-size: 18px;
            border-bottom: 1px solid #ccc;
            line-height: 48px;
          }
          font-weight: normal;
        }
      }
      
      // &:hover,
      &.hover {
        ul.son {
          display: block;
        }
      }
    }
    .active {
      & > a {
        background-color: #fff !important;
        border-bottom: 5px solid #eb565a;
      }
    }
    a.pa {
      color: #000 !important;
      font-size: 20px;
      padding: 10px 0px;
      margin: 0 25px;
      border-bottom: 5px solid #fff;
    }
  }
}

.navbar-header {
  height: 100px;
  .navbar-toggle {
    border: 0;
    &:hover,
    &:focus {
      background-color: #fff !important;
    }

    .icon-bar {
      width: 55px;
      height: 5px;
      background-color: #ef5050 !important;
      & + .icon-bar {
        margin-top: 10px;
      }
    }
  }
}
.flexbtn {
  // float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
@media (max-width: 1200px)  {
  .navbar-inverse {
    .navbar-nav {
    margin:30px 0 ;
    a.pa{
      margin:0 10px;
    }
    }}
}
@media (max-width: 768px) {
  .navbar-inverse {
    .navbar-header {
      height: 50px;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
    }
    .navbar-brand {
      flex: 1;
      //
    }
    .navbar-toggle {
      margin-right: -15px !important;
      .icon-bar {
        width: 22px;
        height: 2px;
        background-color: #ef5050 !important;
        & + .icon-bar {
          margin-top: 5px;
        }
      }
    }

    .navbar-nav {
      margin: 10px;
      float: none;
      .active a {
        background: none !important;
      }
      // li:hover {
      //   // ul.son {
      //   //   display: block;
      //   // }
      //   // border-bottom: 1px solid #ef5050;
      // }
      a {
        margin: 0 15px;
        font-size: 14px !important;
        padding: 5px 0;
        margin: 0;
        border-bottom: none;
      }
    }
  }

  #navbar {
    background-color: #efefef;
  }
  .navbar-inverse {
    height: 50px;
  }
  .navbar-header {
    height: 50px;
    .navbar-brand {
      img {
        height: 50px;
      }
    }
  }
}

@media (max-width: 992px) and (min-width: 768px) {
  
  .navbar-inverse {
    .navbar-nav {
      a {
        margin: 0 15px;
      }
    }
  }
}

@media (max-width: 768px) {
  .glyphicon {
    float: right;
    display: block;
  }
  .navbar-inverse {
    background: #eee !important;
    .navbar-nav {
      li {
        div{
          padding: 10px 0;
           border-bottom: 1px solid #000000 !important;
           a.pa{
             margin:0;
             padding:0 10px;
           }
        }
        ul.son{
           position:static;
           padding-top: 0px;
          margin:10px 0 0;
          background: none;
          li{
            padding:0 15px;
            text-align: left;
            line-height: 30px;
            a{
              font-size: 22px;
              line-height: 30px;
            }
          }
        }
        // border-bottom: 1px solid #ef5050;
      }
      a {
        margin: 0 15px;
        font-size: 14px !important;
        padding: 5px 0;
        margin: 0;
        border-bottom: none !important;
      }
    }
  }
}
</style>